import { FunctionComponent } from 'react';
import { Navigate, Routes as ReactRouterRoutes, Route } from 'react-router';
import { Routing } from './Routing';
import { suspendPageLoad } from './suspendPageLoad';
import { RoutesProperties } from './types';

const WarehouseEmployeeTransportOrderCreationSidebarContainer = suspendPageLoad(
    () =>
        import(
            '../views/warehouseEmployee/transportOrders/sidebars/createSidebar/WarehouseEmployeeTransportOrderCreationSidebar.container'
        ),
);
const CarrierTransportOrderEditSidebarContainer = suspendPageLoad(
    () => import('../views/carrier/sidebars/transportOrderEditSidebar/CarrierTransportOrderEditSidebar.container'),
);
const WarehouseEmployeeTransportOrderEditSidebarContainer = suspendPageLoad(
    () =>
        import(
            '../views/warehouseEmployee/transportOrders/sidebars/editSidebar/WarehouseEmployeeTransportOrderEditSidebar.container'
        ),
);
const AuditorTransportOrderDetailsSidebarContainer = suspendPageLoad(
    () => import('../views/auditor/sidebars/AuditorTransportorderDetailsSidebar.container'),
);
const WarehouseSelectionView = suspendPageLoad(
    () => import('../views/warehouseEmployee/warehouseSelection/WarehouseSelectionView'),
);
const WarehouseEmployeeViewContainer = suspendPageLoad(
    () => import('../views/warehouseEmployee/transportOrders/WarehouseEmployeeView.container'),
);
const CarrierViewContainer = suspendPageLoad(() => import('../views/carrier/CarrierView.container'));
const AuditorViewContainer = suspendPageLoad(() => import('../views/auditor/AuditorView.container'));

export const SidebarsLeft = () => {
    return (
        <ReactRouterRoutes>
            <Route
                path={Routing.transportOrders}
                element={<WarehouseEmployeeTransportOrderCreationSidebarContainer />}
            />
            <Route path='*' element={<></>} />
        </ReactRouterRoutes>
    );
};

export const SidebarsRight = () => {
    return (
        <ReactRouterRoutes>
            <Route path={Routing.carrierView} element={<CarrierTransportOrderEditSidebarContainer />} />
            <Route path={Routing.transportOrders} element={<WarehouseEmployeeTransportOrderEditSidebarContainer />} />
            <Route path={Routing.auditorView} element={<AuditorTransportOrderDetailsSidebarContainer />} />
            <Route path='*' element={<></>} />
        </ReactRouterRoutes>
    );
};

export const Routes: FunctionComponent<RoutesProperties> = (props: RoutesProperties) => {
    return (
        <ReactRouterRoutes>
            <Route path={Routing.warehouseSelection} element={<WarehouseSelectionView />} />
            <Route path={Routing.transportOrders} element={<WarehouseEmployeeViewContainer />} />
            <Route path={Routing.carrierView} element={<CarrierViewContainer />} />
            <Route path={Routing.auditorView} element={<AuditorViewContainer />} />
            <Route path={'/'} element={<Navigate to={defaultRoute(props)} replace={true} />} />
        </ReactRouterRoutes>
    );
};

export const defaultRoute = (props: RoutesProperties): any => {
    const { canAccessAuditorView, canAccessCarrierView } = props;
    if (canAccessAuditorView) {
        return Routing.auditorView;
    } else if (canAccessCarrierView) {
        return Routing.carrierView;
    }
    return Routing.warehouseSelection;
};
